import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getJuliangOrganizations(data) {
    return request.get(`/${platform}/juliang_organizations`, data)
}

export function deleteJuliangOrganizations(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/juliang_organizations/${ids}`)
}

export function storeOrUpdateJuliangOrganization(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/juliang_organizations/${data.id}` : `/${platform}/juliang_organizations`
    return request[method](url, data)
}

// 查询可同步的组织列表（供弹窗展示用）
export function getJuliangOrgSyncList() {
    return request.get(`/${platform}/juliang_organizations/sync_list`)
}

// 同步素材到巨量组织
export function uploadToMediaOrganization(data) {
    return request.post(`/${platform}/juliang_organizations/upload_to_media_organization`, data)
}
